<template>
  <div class="submit-container">
    <div class="submit-content">
      <header>
        <router-link class="go-back" to="/">
          <span>←</span>Back
        </router-link>
      </header>
      <h1>
        Submit your palette 🎉
      </h1>
      <p>
        Join the the color revolution and represent your country on the next wave of Flat UI Colors.
        <br><br> We are here to provide an ultimate list of color palettes to everyone. Help us by preparing a matching set of 20 colors and take your place on Flat UI Colors 3.
        <br><br> We’ll first prioritize the countries which are not in the current list, but eventually publish all the palettes.
        <br>
        <a class="button" href="http://gogogo.flatuicolors.com/new-palette" target="_blank" @click="$ga.event('submit-palette');">
          Submit Your Palette
        </a>
      </p>
    </div>
    <Footer/>
  </div>
</template>

<script>
import Footer from "@/components/Footer";

export default {
  name: "Submit",
  components: {
    Footer
  },
  data() {
    return {
      twitterUrl : process.env.API_URL + '/twitter?returnUrl=' + location.host
    };
  },
  metaInfo: {
    title: "Submit"
  },
  beforeMount(){
    $crisp.push(['do', 'chat:show']);
  },
  methods: {}
};
</script>
<style lang="scss" scoped>
@import "~@/styles/common.scss";
.submit-container {
  @include sub-container();
  .submit-content {
    @include sub-content();
  }
  header {
    @include sub-header();
  }
}

@include sub-mobile();
</style>



// WEBPACK FOOTER //
// src/components/Submit.vue